// extracted by mini-css-extract-plugin
export var image = "ct_c3";